import { Frame } from '../components/Frame';
import { KrabenMark } from '../components/KrabenMark';
import { downloadExport } from '../lib/crew';
import { useViewed } from '../lib/viewed';

export function Closed({ message }: { message?: string }) {
  useViewed('closed');
  return (
    <Frame>
      <div className="stack" style={{ alignItems: 'center', textAlign: 'center', paddingTop: 40 }}>
        <KrabenMark size={120} />
        <h1>Kindling is closing.</h1>
        <p className="why">{message || 'Download everything you made. Thank you for making things here.'}</p>
        <button className="btn" onClick={() => downloadExport().catch(() => {})}>Download everything you made</button>
      </div>
    </Frame>
  );
}
